import React from 'react'
import Dialog from '../Dialog'
import { Grid } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import styles from '../../../styles'
import CloseIcon from '@mui/icons-material/Close'

const useStyles = makeStyles()(
	(theme) => ({
		...styles(theme),
		visite3DContainer: {
			margin: 'auto',
			marginTop: 50
		},
		iconStyle: {
			'&:hover': {
				background: theme.palette.blue['5']
			},
			position: 'absolute',
			top: 15,
			right: 12,
			borderRadius: '100%',
			color: theme.palette.blue.main,
			cursor: 'pointer',
			zIndex: 2,
			fontSize: 20,
			padding: 5
		},
		iframeStyle: {
			aspectRatio: '1200/676',
			maxHeight: '90vh'
		}
	})
)

interface AcceptingProps {
	onCloseDialog: () => void,
	isOpen: boolean,
	iframeURL: string,
}

type PopinVisite3DProps = AcceptingProps

const PopinVisite3D: React.FC<PopinVisite3DProps> = (
	{
		onCloseDialog,
		isOpen,
		iframeURL
	}
) => {
	const { classes } = useStyles()

	return (
		<Dialog
			onCloseDialog={onCloseDialog}
			open={isOpen}
		>
			<>
				<CloseIcon
					onClick={onCloseDialog}
					className={classes.iconStyle}
				/>

				<Grid
					container
					item
					xs={12}
					direction="column"
					className={classes.visite3DContainer}
				>
					<iframe
						className={classes.iframeStyle}
						title="Visite 3D"
						width="100%"
						src={iframeURL}
					/>
				</Grid>
			</>
		</Dialog>
	)
}

export default PopinVisite3D